/** Connects the backbone model to BookCoverView.tsx */
import Backbone from "backbone";
import * as preact from "preact";

import models from "models/models";
import readlangClient from "../readlangClient";
import * as signupModal from "../signupModal";
import * as libraryDocumentViewUtils from "../views/libraryDocumentViewUtils";
import BookCoverView from "./BookCoverView";

// Types for props
interface Props {
  book: any; // Book backbonejs model
  userID: string;
  compactMode?: boolean;
}

// Types for state
type State = {};

// Bind generics to ExpandableProps and ExpandableState
export default class BookCoverConnector extends preact.Component<Props, State> {
  events = { ...Backbone.Events } as Backbone.Events;

  constructor(props: Props) {
    super(props);

    this.events.listenTo(this.props.book, "change", () => {
      console.log("force update...");
      this.forceUpdate();
    });

    this.state = {};
  }

  clickHeart() {
    if (this.props.book.get("yourVote") > 0) {
      this.props.book.vote(0);
    } else {
      this.props.book.vote(1);
    }
  }

  async clickReadLater() {
    if (await readlangClient.isLocalMode()) {
      signupModal.show({
        headingHtml: "<h2>Sign in to <strong>save texts</strong></h2>",
        models,
      });
      return;
    }

    const tagName = "queue";
    this.props.book.addTag(tagName);
  }

  async clickHide() {
    this.props.book.save(
      {
        hide: true,
      },
      { patch: true }
    );
  }

  render() {
    const templateData = libraryDocumentViewUtils.calcTemplateData(
      this.props.book.viewJSON(this.props.userID, true),
      {
        userID: this.props.userID,
        groupMode: false,
      }
    );

    return (
      <BookCoverView
        {...templateData}
        clickHeart={() => this.clickHeart()}
        clickReadLater={() => this.clickReadLater()}
        clickHide={() => this.clickHide()}
        hidden={this.props.book.get("hide")}
        compactMode={this.props.compactMode}
        user={models.user}
      />
    );
  }
}
